import { subjectColors, mySubjectColors } from '../consts/subject';
import { VideoCard } from '../model/home';
import { IChatMessage, Subject } from '../model/video';
import { isSameDay } from './DateUtils';

export function getSubjectByVideo(
  video: VideoCard,
): [Subject, { bg: string; text: string; border: string }] {
  const subject = video.subject || 'Others';
  const subjectColor = subjectColors[subject]
    ? subjectColors[subject]
    : subjectColors['Others'];
  return [subject, subjectColor];
}
export function getMySubjectByVideo(
  video: VideoCard,
): [Subject, { bg: string; text: string; border: string }] {
  const subject = video.subject || 'Others';
  const subjectColor = mySubjectColors[subject]
    ? mySubjectColors[subject]
    : mySubjectColors['Others'];
  return [subject, subjectColor];
}

export function addSystemTimeInMsgList(_msgs: IChatMessage[]): IChatMessage[] {
  const msglistRes: IChatMessage[] = [];
  const noTimeList = _msgs.filter((item) => item.role !== 'system');
  let lastTime = new Date(1900, 1, 1);
  for (let i = 0; i < noTimeList.length; i++) {
    //
    if (!isSameDay(_msgs[i].timestamp, lastTime)) {
      lastTime = _msgs[i].timestamp;
      msglistRes.push({
        role: 'system',
        timestamp: lastTime,
        content: [''],
      });
    }
    msglistRes.push(_msgs[i]);
  }
  return msglistRes;
}
export const formatDuration = (_seconds: number) => {
  const seconds = Math.floor(_seconds);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};
